module.exports = __webpack_public_path__ + "img/rectangle.2111013b.svg";